import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import meeting from './meeting'
import dashboard from './dashboard'
import requestList from './request-list'
import error from './error'
import sso from './sso'
import overview from './overview'
import user from './user'
import lillyUser from './lilly_user'
import se from './se'
import content from './content'
import eventManagement from './event-management'
import analytics from './analytics'
import teamContent from './team-content'
import push from './push'
import customer from './customer'
import batchOperationTool from './batch-operation-tool'
import { parseTitle } from '../utils/tab-title'
import message from './message'
import preview from './preview'
// import { RoleCode } from "@/utils/role-constant";
import { MessageBox } from 'element-ui'

Vue.use(VueRouter)

const WHITE_LIST = ['OnlinePreview']

const routes = [
  ...error,
  ...sso,
  ...preview,
  {
    path: '/',
    name: 'index',
    redirect: '/authorise',
    component: () => import('../components/layout/index.vue'),
    children: [
      ...meeting,
      ...requestList,
      ...overview,
      ...lillyUser,
      ...se,
      ...content,
      ...teamContent,
      ...push,
      ...analytics,
      ...eventManagement,
      ...customer,
      ...batchOperationTool,
      ...message,
      ...dashboard
    ]
  },
  {
    path: '*',
    redirect: '/error/404',
  },
]
if (process.env.NODE_ENV === 'development') {
  routes.unshift(...user)
}

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  const { token, menus, role } = store.state
  if (to.meta.title) {
    document.title = `eMSL - ${parseTitle(to.meta.title)} `
  }

  console.log(to.name)
  if (from.name === 'sr-menu' && store.state.editFlag) {
    //sr-menu有未提交的表单需要确认是否提交
    MessageBox.confirm('Changes not saved, do you want to save?', 'Attention', {
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    })
        .then(() => {
          store.dispatch('saveFormEdit', store.state.editForm)
              .then(() => {})
              .catch(() => {})
        })
        .catch(() => {
          store.state.editFlag = false
          store.state.editForm = {}
        })
  }

  if (WHITE_LIST.includes(to.name)) return next()


  const isAuth = to.name === 'authorise' || to.name === 'UserLogin'
  const isErrorPage = to.name === 'NotFound' || to.name === 'Deny'
  if (!isAuth && !isErrorPage && token) {
    localStorage.setItem('redirect', `${to.path}#${role}`)
  }
  if (isErrorPage) next()
  else if (!isAuth && !token) {
    localStorage.setItem('redirect', to.fullPath)
    next('/authorise')
  } else if (isAuth && token && menus.length > 0)
    if (menus[0].subMenus) {
      next(menus[0].subMenus[0].url)
    } else {
      next(menus[0].url)
    }
  else if (!isAuth && token && !isErrorPage) {
    if (hasPer(to.path)) next()
    else {
      if (menus.length < 0) next('/error/404')
      else {
        if (menus[0].subMenus) {
          next(menus[0].subMenus[0].url)
        } else {
          next(menus[0].url)
        }
      }
    }
  } else next()
})

function hasPer(url) {
  if (/^\/(message\/|online-preview)/.test(url)) return true
  return store.state.menus.some((menu) => {
    if (menu.subMenus) {
      return menu.subMenus.some(
        (subMenu) => subMenu.url === url || url.indexOf(subMenu.url) >= 0
      )
    } else {
      return menu.url === url || url.indexOf(menu.url) >= 0
    }
  })
}

export default router
